<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :detailData="scopedDetailData"
      :apiUrl="apiUrl">

      <template #form="scope">
        <div class="form-group">
          <label>Jabatan</label>
          <input class="form-control d-block w-100" v-model="scope.data.Name">
        </div>

        <button class="btn btn-primary btn-sm btn-block" type="submit">Simpan</button>
      </template>

      <template #detail="scope">
        <h6 class="m-0 font-weight-bold text-primary">{{ scope.data.Name }}</h6>

        <ul class="list-group mb-3" v-if="scope.data.Departments.length">
          <li class="list-group-item d-flex justify-content-between align-items-center" v-for="department in scope.data.Departments">
            {{ department.Name }}

            <button class="btn btn-danger btn-sm mr-1" @click="deleteAppendItem(department.ID)">
              <i class="fas fa-trash" />
            </button>
          </li>     
        </ul>
        <b-alert show variant="light" v-else>kosong</b-alert>

        <div v-show="!showAppendForm">
          <button class="btn btn-primary d-block w-100" @click="showAppendForm = true">Tambah</button>
        </div>

        <div v-show="showAppendForm">
          <div class="form-group">
            <v-select
              placeholder="Tambah Departemen"
              taggable
              push-tags
              label="Name"
              v-model="appendForm.Department"
              :options="listOptions.departments"
              :create-option="val => ({ ID: 0, Name: val })">

              <template v-slot:option="option">
                <span v-if="option.ID">{{ option.Name }}</span>
                <span v-else><em>Buat "{{ option.Name }}"</em></span>
              </template>
            </v-select>
          </div>

          <div class="row">
            <div class="col">
              <b-button type="button" @click="saveAppendItem" variant="success" block>Simpan</b-button>
            </div>
            <div class="col">
              <b-button type="button" variant="danger" block @click="showAppendForm = false">Batal</b-button>
            </div>
          </div>
        </div>
      </template>

    </AppToolbox>

    
    <AppTable :apiUrl="apiUrl" :fields="tableFields" :search="search" @onSelectItem="selectedItem = $event" />

  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.onRefresh()

    this.fetchOptionData()
  },
  data() {
    return {
      apiUrl: '/position',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'Name', label: 'Departemen' },
        { key: 'Departments', label: 'Jumlah Departemen', formatter: value => `<span class="badge badge-info">${value.length} Departemen</span>`}
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {
        ID: null,
        Name: ''
      },
      scopedDetailData: {
        ID: '',
        Name: '',
        Departments: []
      },
      showAppendForm: false,
      listOptions: {
        departments: []
      },
      appendForm: {
        Department: {}
      }
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    
    fetchOptionData () {
      this.$axios.get('/department').then((res) => {
        this.listOptions.departments = res.data
      })
    },

    saveAppendItem () {
      this.$axios.post(`/position/append/department/${this.scopedDetailData.ID}`, {
        ID: this.appendForm.Department.ID,
        Name: this.appendForm.Department.Name
      }).then(res => {
        this.$emit('refreshTable')
        this.scopedDetailData.departments.push(res.data.Departments[0])
        this.showAppendForm = false

        this.$bvToast.toast('Berhasil disimpan', {
          title: 'Sukses!!',
          variant: 'success',
          solid: true
        })
      })
    },

    deleteAppendItem (id) {
      this.$axios.post(`/position/delete/department/${this.scopedDetailData.ID}`, {
        ID: id
      }).then(res => {
        this.$emit('refreshTable')

        this.$bvModal.hide('modalDetail')

        this.$bvToast.toast('Berhasil dihapus', {
          title: 'Sukses!!',
          variant: 'success',
          solid: true
        })
      })
    }
  }
}
</script>


<style>
.badge-pointer {
  cursor: pointer !important;
}
</style>